import { render, staticRenderFns } from "./addProgramSidebarView.vue?vue&type=template&id=8f242f62&scoped=true&"
import script from "./addProgramSidebarView.vue?vue&type=script&lang=js&"
export * from "./addProgramSidebarView.vue?vue&type=script&lang=js&"
import style0 from "./addProgramSidebarView.vue?vue&type=style&index=0&id=8f242f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f242f62",
  null
  
)

export default component.exports